export const HOSTNAME_PATTERN =
  /^(?=.{1,253}$)(?!-)([a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)(?:\.(?!-)([a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?))+$/;

export function isValidSendingHostname(input: string): boolean {
  return HOSTNAME_PATTERN.test(input.trim().toLowerCase());
}

export function composeFromAddress(local: string, host: string): string {
  const l = local.trim();
  if (!l || !host) return "";
  return `${l}@${host}`;
}

export function splitFromAddress(address: string | null | undefined): {
  local: string;
  host: string;
} {
  if (!address) return { local: "", host: "" };
  const at = address.indexOf("@");
  if (at <= 0) return { local: "", host: "" };
  return {
    local: address.slice(0, at),
    host: address.slice(at + 1).toLowerCase(),
  };
}
